import api from "./api";

export const getPayment = async (params) => {
  return api
    .get({
      endpoint: "/x/transactions",
      port: process.env.REACT_APP_PORT_PAYMENT,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
